export const API_ROUTES = {
  AUTHEN: {
    LOG_IN: "/login/client",
    REGISTER: "/register",
    LOG_OUT: "/logout",
    FORGOT: "/forgot-password",
    VERIFY: "/verify-code",
    RESET: "/reset-password",
    REFRESH_TOKEN: "/refresh/client",
  },
  TICKET: {
    GET_ALL: "/user/ticket",
    GET_BY_ID: "/user/ticket/",
    CREATE: "/user/ticket/create",
    UPDATE: "/user/ticket/",
    DELETE: "/user/ticket/",
  },
  MANAGER: {
    GET_ALL_STAFF: "/manager/staff",
    GET_STAFF_BY_ID: "/manager/staff",
    UPDATE_INFO_STAFF: "/manager/staff",
    DELETE_STAFF: "/manager/staff",
    CREATE_STAFF: "/manager/staff",
  },
  ACCOUNT: {
    GET_INFO: "user/me/client",
    UPDATE: "user/me/client",
  },
  DOCUMENT: {
    GET: "/user/documents",
    GET_BY_ID: "/user/documents",
  },
  PROCEDURE: {
    GET: "/user/procedure",
    GET_BY_ID: "/user/procedure",
    GET_BY_CATEGORY: "/user/procedure/c",
  },
  POSTS: {
    GET: "/user/posts",
    GET_BY_ID: "/user/posts",
    GET_POSTS: "/user/posts",
    GET_POSTS_BY_ID: "/user/posts/:postId",
    EXPORT_AUTHORIZATION_FILE: "/user/word-template/render",
  },
  FILE: {
    GET_ALL: "/user/list",
    GET_ORIGINAL: "/user/list/original",
    GET_BY_ID: "/user",
    DELETE: "/user/list",
    DUPLICATE: "/user/p/duplicate",
    GET_PROFILE_ESTIMATE: "/user/profile-estimate/:profileId",
    GET_ESTIMATE_ADJUSTMENT_HISTORY:
      "/admin/estimate/:profileId/adjustment-history",
  },
  SERVICE: {
    GET_ALL: "/user/service",
    GET_SERVICE_BI_ID: "/user/service",
    GET_ALL_CATEGORY: "/user/category",
    GET_SERVICE_BY_CATEGORY_ID: "/user/category",
    GET_LIST_USER_SERVICE: "/user/service",
    GET_LIST_USER_SERVICE_SHORT: "/user/service/short",
  },
  FORM: {
    ADD_NEW: "/user/submit",
    UPDATE: "/user/update",
  },
  NOTI: {
    GET_ALL: "/user/noti",
    DELETE_ALL: "/user/noti",
    MARK_AS_READ: "/user/noti",
    GET_COUNT: "/user/noti/count",
  },
  CONTRACT: {
    GET_ALL: "/user/contract",
    GET_BY_ID: "/user/contract",
  },
  BANNER: {
    GET_ALL: "/user/news",
    GET_BY_ID: "/user/news",
  },
  REPORT: {
    GET_REPORT_CLIENT_SERVICE: "/user/report-client/service",
    GET_REPORT_CLIENT_PROFILE: "/user/report-client/profile",
    GET_REPORT_CLIENT_PROFILE_ORIGINAL: "/user/report-client/profile/original",
    GET_REPORT_CLIENT_FINANCE: "/user/report-client/finance",
    EXPORT_PDF: "/pdf/client/export-pdf",
    EXPORT_ORIGINAL_PROFILE_PDF: "/pdf/client/original-profile/export-pdf",
  },
  ORDER: {
    GET_LIST_USER_ORDER: "/user/order",
    GET_DETAIL_USER_ORDER: "/user/order/:orderId",
  },
  VAT: {
    GET_VAT_CONFIG: "/user/vat-config",
  },
  FIREBASE: {
    UPLOAD_FILE: "/firebase/upload-image",
    DELETE_FILE: "/firebase/delete-image",
  },
};
